import styled from '@emotion/styled';
import { colors } from '../assets/colors';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.grey[1]};
`;
